
import React from 'react';
import { Loader2 } from 'lucide-react';

const AnalyticsLoading = () => {
  return (
    <div className="h-60 flex flex-col items-center justify-center">
      <Loader2 className="h-8 w-8 animate-spin text-sage mb-2" />
      <span className="text-gray-600">Loading analytics data...</span>
      <span className="text-gray-400 text-sm">This may take a few moments</span>
    </div>
  );
};

export default AnalyticsLoading;
